function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import ItemBoundable from './ItemBoundable';
import PriorityQueue from '../../util/PriorityQueue';
import hasInterface from '../../../../../hasInterface';
import SpatialIndex from '../SpatialIndex';
import AbstractNode from './AbstractNode';
import Double from '../../../../../java/lang/Double';
import Collections from '../../../../../java/util/Collections';
import BoundablePair from './BoundablePair';
import ArrayList from '../../../../../java/util/ArrayList';
import Comparator from '../../../../../java/util/Comparator';
import Serializable from '../../../../../java/io/Serializable';
import Envelope from '../../geom/Envelope';
import Assert from '../../util/Assert';
import AbstractSTRtree from './AbstractSTRtree';
import ItemDistance from './ItemDistance';
var STRtree = /*#__PURE__*/function (_AbstractSTRtree) {
  function STRtree() {
    var _this;
    _classCallCheck(this, STRtree);
    _this = _callSuper(this, STRtree);
    STRtree.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(STRtree, _AbstractSTRtree);
  return _createClass(STRtree, [{
    key: "createParentBoundablesFromVerticalSlices",
    value: function createParentBoundablesFromVerticalSlices(verticalSlices, newLevel) {
      Assert.isTrue(verticalSlices.length > 0);
      var parentBoundables = new ArrayList();
      for (var i = 0; i < verticalSlices.length; i++) {
        parentBoundables.addAll(this.createParentBoundablesFromVerticalSlice(verticalSlices[i], newLevel));
      }
      return parentBoundables;
    }
  }, {
    key: "createNode",
    value: function createNode(level) {
      return new STRtreeNode(level);
    }
  }, {
    key: "size",
    value: function size() {
      if (arguments.length === 0) {
        return _superPropGet(STRtree, "size", this, 1).call(this);
      } else return _superPropGet(STRtree, "size", this, 1).apply(this, arguments);
    }
  }, {
    key: "insert",
    value: function insert() {
      if (arguments.length === 2 && arguments[1] instanceof Object && arguments[0] instanceof Envelope) {
        var itemEnv = arguments[0];
        var item = arguments[1];
        if (itemEnv.isNull()) {
          return null;
        }
        _superPropGet(STRtree, "insert", this, 1).call(this, itemEnv, item);
      } else return _superPropGet(STRtree, "insert", this, 1).apply(this, arguments);
    }
  }, {
    key: "getIntersectsOp",
    value: function getIntersectsOp() {
      return STRtree.intersectsOp;
    }
  }, {
    key: "verticalSlices",
    value: function verticalSlices(childBoundables, sliceCount) {
      var sliceCapacity = Math.trunc(Math.ceil(childBoundables.size() / sliceCount));
      var slices = new Array(sliceCount).fill(null);
      var i = childBoundables.iterator();
      for (var j = 0; j < sliceCount; j++) {
        slices[j] = new ArrayList();
        var boundablesAddedToSlice = 0;
        while (i.hasNext() && boundablesAddedToSlice < sliceCapacity) {
          var childBoundable = i.next();
          slices[j].add(childBoundable);
          boundablesAddedToSlice++;
        }
      }
      return slices;
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 1) {
        var searchEnv = arguments[0];
        return _superPropGet(STRtree, "query", this, 1).call(this, searchEnv);
      } else if (arguments.length === 2) {
        var _searchEnv = arguments[0];
        var visitor = arguments[1];
        _superPropGet(STRtree, "query", this, 1).call(this, _searchEnv, visitor);
      }
    }
  }, {
    key: "getComparator",
    value: function getComparator() {
      return STRtree.yComparator;
    }
  }, {
    key: "createParentBoundablesFromVerticalSlice",
    value: function createParentBoundablesFromVerticalSlice(childBoundables, newLevel) {
      return _superPropGet(STRtree, "createParentBoundables", this, 1).call(this, childBoundables, newLevel);
    }
  }, {
    key: "remove",
    value: function remove() {
      if (arguments.length === 2 && arguments[1] instanceof Object && arguments[0] instanceof Envelope) {
        var itemEnv = arguments[0];
        var item = arguments[1];
        return _superPropGet(STRtree, "remove", this, 1).call(this, itemEnv, item);
      } else return _superPropGet(STRtree, "remove", this, 1).apply(this, arguments);
    }
  }, {
    key: "depth",
    value: function depth() {
      if (arguments.length === 0) {
        return _superPropGet(STRtree, "depth", this, 1).call(this);
      } else return _superPropGet(STRtree, "depth", this, 1).apply(this, arguments);
    }
  }, {
    key: "createParentBoundables",
    value: function createParentBoundables(childBoundables, newLevel) {
      Assert.isTrue(!childBoundables.isEmpty());
      var minLeafCount = Math.trunc(Math.ceil(childBoundables.size() / this.getNodeCapacity()));
      var sortedChildBoundables = new ArrayList(childBoundables);
      Collections.sort(sortedChildBoundables, STRtree.xComparator);
      var verticalSlices = this.verticalSlices(sortedChildBoundables, Math.trunc(Math.ceil(Math.sqrt(minLeafCount))));
      return this.createParentBoundablesFromVerticalSlices(verticalSlices, newLevel);
    }
  }, {
    key: "nearestNeighbour",
    value: function nearestNeighbour() {
      if (arguments.length === 1) {
        if (hasInterface(arguments[0], ItemDistance)) {
          var itemDist = arguments[0];
          var bp = new BoundablePair(this.getRoot(), this.getRoot(), itemDist);
          return this.nearestNeighbour(bp);
        } else if (arguments[0] instanceof BoundablePair) {
          var initBndPair = arguments[0];
          return this.nearestNeighbour(initBndPair, Double.POSITIVE_INFINITY);
        }
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof STRtree && hasInterface(arguments[1], ItemDistance)) {
          var tree = arguments[0];
          var _itemDist = arguments[1];
          var _bp = new BoundablePair(this.getRoot(), tree.getRoot(), _itemDist);
          return this.nearestNeighbour(_bp);
        } else if (arguments[0] instanceof BoundablePair && typeof arguments[1] === 'number') {
          var _initBndPair = arguments[0];
          var maxDistance = arguments[1];
          var distanceLowerBound = maxDistance;
          var minPair = null;
          var priQ = new PriorityQueue();
          priQ.add(_initBndPair);
          while (!priQ.isEmpty() && distanceLowerBound > 0.0) {
            var bndPair = priQ.poll();
            var currentDistance = bndPair.getDistance();
            if (currentDistance >= distanceLowerBound) break;
            if (bndPair.isLeaves()) {
              distanceLowerBound = currentDistance;
              minPair = bndPair;
            } else {
              bndPair.expandToQueue(priQ, distanceLowerBound);
            }
          }
          return [minPair.getBoundable(0).getItem(), minPair.getBoundable(1).getItem()];
        } else if (arguments[0] instanceof BoundablePair && Number.isInteger(arguments[1])) {
          var _initBndPair2 = arguments[0];
          var k = arguments[1];
          return this.nearestNeighbour(_initBndPair2, Double.POSITIVE_INFINITY, k);
        }
      } else if (arguments.length === 3) {
        if (hasInterface(arguments[2], ItemDistance) && arguments[0] instanceof Envelope && arguments[1] instanceof Object) {
          var env = arguments[0];
          var item = arguments[1];
          var _itemDist2 = arguments[2];
          var bnd = new ItemBoundable(env, item);
          var _bp2 = new BoundablePair(this.getRoot(), bnd, _itemDist2);
          return this.nearestNeighbour(_bp2)[0];
        } else if (Number.isInteger(arguments[2]) && arguments[0] instanceof BoundablePair && typeof arguments[1] === 'number') {
          var _initBndPair3 = arguments[0];
          var _maxDistance = arguments[1];
          var _k = arguments[2];
          var _distanceLowerBound = _maxDistance;
          var _priQ = new PriorityQueue();
          _priQ.add(_initBndPair3);
          var kNearestNeighbors = new PriorityQueue();
          while (!_priQ.isEmpty() && _distanceLowerBound >= 0.0) {
            var _bndPair = _priQ.poll();
            var _currentDistance = _bndPair.getDistance();
            if (_currentDistance >= _distanceLowerBound) {
              break;
            }
            if (_bndPair.isLeaves()) {
              if (kNearestNeighbors.size() < _k) {
                kNearestNeighbors.add(_bndPair);
              } else {
                var bp1 = kNearestNeighbors.peek();
                if (bp1.getDistance() > _currentDistance) {
                  kNearestNeighbors.poll();
                  kNearestNeighbors.add(_bndPair);
                }
                var bp2 = kNearestNeighbors.peek();
                _distanceLowerBound = bp2.getDistance();
              }
            } else {
              _bndPair.expandToQueue(_priQ, _distanceLowerBound);
            }
          }
          return STRtree.getItems(kNearestNeighbors);
        }
      } else if (arguments.length === 4) {
        var _env = arguments[0];
        var _item = arguments[1];
        var _itemDist3 = arguments[2];
        var _k2 = arguments[3];
        var _bnd = new ItemBoundable(_env, _item);
        var _bp3 = new BoundablePair(this.getRoot(), _bnd, _itemDist3);
        return this.nearestNeighbour(_bp3, _k2);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return STRtree;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SpatialIndex, Serializable];
    }
  }], [{
    key: "centreX",
    value: function centreX(e) {
      return STRtree.avg(e.getMinX(), e.getMaxX());
    }
  }, {
    key: "avg",
    value: function avg(a, b) {
      return (a + b) / 2;
    }
  }, {
    key: "getItems",
    value: function getItems(kNearestNeighbors) {
      var items = new Array(kNearestNeighbors.size()).fill(null);
      var count = 0;
      while (!kNearestNeighbors.isEmpty()) {
        var bp = kNearestNeighbors.poll();
        items[count] = bp.getBoundable(0).getItem();
        count++;
      }
      return items;
    }
  }, {
    key: "centreY",
    value: function centreY(e) {
      return STRtree.avg(e.getMinY(), e.getMaxY());
    }
  }]);
}(AbstractSTRtree);
export { STRtree as default };
var STRtreeNode = /*#__PURE__*/function (_AbstractNode) {
  function STRtreeNode() {
    var _this2;
    _classCallCheck(this, STRtreeNode);
    _this2 = _callSuper(this, STRtreeNode);
    STRtreeNode.constructor_.apply(_this2, arguments);
    return _this2;
  }
  _inherits(STRtreeNode, _AbstractNode);
  return _createClass(STRtreeNode, [{
    key: "computeBounds",
    value: function computeBounds() {
      var bounds = null;
      for (var i = this.getChildBoundables().iterator(); i.hasNext();) {
        var childBoundable = i.next();
        if (bounds === null) {
          bounds = new Envelope(childBoundable.getBounds());
        } else {
          bounds.expandToInclude(childBoundable.getBounds());
        }
      }
      return bounds;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return STRtreeNode;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(AbstractNode);
STRtreeNode.constructor_ = function () {
  var level = arguments[0];
  AbstractNode.constructor_.call(this, level);
};
STRtree.STRtreeNode = STRtreeNode;
STRtree.constructor_ = function () {
  if (arguments.length === 0) {
    STRtree.constructor_.call(this, STRtree.DEFAULT_NODE_CAPACITY);
  } else if (arguments.length === 1) {
    var nodeCapacity = arguments[0];
    AbstractSTRtree.constructor_.call(this, nodeCapacity);
  }
};
STRtree.serialVersionUID = 259274702368956900;
STRtree.xComparator = new (/*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  return _createClass(_class, [{
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }, {
    key: "compare",
    value: function compare(o1, o2) {
      return AbstractSTRtree.compareDoubles(STRtree.centreX(o1.getBounds()), STRtree.centreX(o2.getBounds()));
    }
  }]);
}())();
STRtree.yComparator = new (/*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }
  return _createClass(_class2, [{
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }, {
    key: "compare",
    value: function compare(o1, o2) {
      return AbstractSTRtree.compareDoubles(STRtree.centreY(o1.getBounds()), STRtree.centreY(o2.getBounds()));
    }
  }]);
}())();
STRtree.intersectsOp = new (/*#__PURE__*/function () {
  function _class3() {
    _classCallCheck(this, _class3);
  }
  return _createClass(_class3, [{
    key: "interfaces_",
    get: function get() {
      return [IntersectsOp];
    }
  }, {
    key: "intersects",
    value: function intersects(aBounds, bBounds) {
      return aBounds.intersects(bBounds);
    }
  }]);
}())();
STRtree.DEFAULT_NODE_CAPACITY = 10;